var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c(
        "PageHeader",
        {
          staticClass: "page-header-comission",
          attrs: { pageTitle: "Comissões" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", gap: "0.5rem" } },
            [
              _c("SelectYear", {
                model: {
                  value: _vm.search.year,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "year", $$v)
                  },
                  expression: "search.year"
                }
              }),
              _vm._v(" "),
              _c("SelectMonth", {
                model: {
                  value: _vm.search.month,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "month", $$v)
                  },
                  expression: "search.month"
                }
              }),
              _vm._v(" "),
              _vm.oldCommissionList.length
                ? _c("SelectPromoter", {
                    attrs: { traderList: _vm.traderList },
                    model: {
                      value: _vm.search.trader,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "trader", $$v)
                      },
                      expression: "search.trader"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.oldCommissionList.length
                ? _c("SelectProfile", {
                    model: {
                      value: _vm.search.profile,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "profile", $$v)
                      },
                      expression: "search.profile"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.oldCommissionList.length
                ? _c("SelectInvoiceNumberStatus", {
                    attrs: { invoiceNumberList: _vm.invoiceNumberList },
                    model: {
                      value: _vm.search.invoiceNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "invoiceNumber", $$v)
                      },
                      expression: "search.invoiceNumber"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.oldCommissionList.length
                ? _c("SelectCommissionStatus", {
                    model: {
                      value: _vm.search.status,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "status", $$v)
                      },
                      expression: "search.status"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.search.year && _vm.search.month
                ? _c(
                    "BaseButtonComponent",
                    {
                      attrs: { variant: "primary-action" },
                      on: {
                        click: function($event) {
                          return _vm.getAll()
                        }
                      }
                    },
                    [_vm._v("\n        Buscar\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "VueJsonToCsv",
                {
                  attrs: {
                    block: "",
                    "json-data": _vm.CSVCommissionList,
                    separator: ";"
                  }
                },
                [
                  _c(
                    "BaseButtonComponent",
                    {
                      attrs: {
                        block: "",
                        variant: "primary-action",
                        disabled: !_vm.CSVCommissionList.length
                      }
                    },
                    [_vm._v("\n          CSV\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center"
              }
            },
            [
              _c("CommissionCounter", {
                key: _vm.commissionList.length,
                attrs: { commissionList: _vm.commissionList }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    gap: "0.5rem",
                    height: "100%"
                  }
                },
                [
                  _c(
                    "BaseButtonComponent",
                    {
                      attrs: {
                        disabled: !_vm.openCommissionList.length,
                        variant: "primary-action"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeCommissionPeriod()
                        }
                      }
                    },
                    [_vm._v("\n          Fechar Período\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "BaseButtonComponent",
                    {
                      attrs: {
                        disabled: !_vm.commissionList.length,
                        variant: "primary-action"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleMarkCommissionsItemAsPaidInBatch()
                        }
                      }
                    },
                    [_vm._v("\n          Pagou Lote\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "BaseButtonComponent",
                    {
                      attrs: {
                        disabled: !_vm.commissionList.length,
                        variant: "primary-action"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showDeleteCommissionInBatchDialog()
                        }
                      }
                    },
                    [_vm._v("\n          Deletar Lote\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isLoading ? _c("loading-list") : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.commissionList.length !== 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between flex-column" },
            [
              _c(
                "Table",
                {
                  staticClass: "commission-table",
                  staticStyle: { "margin-top": "1rem" }
                },
                [
                  _c(
                    "TableHeader",
                    [
                      _c(
                        "TableRow",
                        _vm._l(_vm.commissionColumns, function(
                          commissionCol,
                          index
                        ) {
                          return _c(
                            "TableHead",
                            { key: `${commissionCol}_${index}` },
                            [
                              _c("ColumnHeader", {
                                attrs: {
                                  sort: commissionCol.sort,
                                  somatory: commissionCol.somatory,
                                  columnName: commissionCol.name,
                                  columnKey: commissionCol.key,
                                  columnType: commissionCol.columnType,
                                  currentColumnFiltered:
                                    _vm.currentColumnFiltered,
                                  sortDirection: _vm.sortDirection,
                                  dataList: _vm.commissionList
                                },
                                on: {
                                  sortListByKey: function($event) {
                                    return _vm.sortListByKey(commissionCol.key)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TableBody",
                    _vm._l(_vm.commissionList, function(commision, index) {
                      return _c(
                        "TableRow",
                        { key: `${commision}_${index}` },
                        [
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(commision.nameCoupon) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderProfileColumnValue", {
                                attrs: { profile: commision.profile }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(commision.installationNumber) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: commision.nameTrader }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: commision.investorCustomerName }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: commision.value }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(commision.comission) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: commision.comissionCalc }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderCommissionStatusColumnValue", {
                                attrs: { value: commision.status }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(commision.invoice) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(commision.xmlInvoice) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderDateColumnValue", {
                                attrs: { value: commision.inputDate }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderDateColumnValue", {
                                attrs: { value: commision.paidDate }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticClass: "options-button" },
                            [
                              _c(
                                "BaseButtonComponent",
                                {
                                  attrs: {
                                    variant: "confirmation-action",
                                    disabled:
                                      commision.status !== "INVOICE_CREATED"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleChangeCommissionToPaid(
                                        commision
                                      )
                                    }
                                  }
                                },
                                [_vm._v("\n              Pagou\n            ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "BaseButtonComponent",
                                {
                                  attrs: {
                                    variant: "danger",
                                    disabled: !commision.id
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showDeleteCommissionDialog(
                                        commision.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Deletar\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(commision.contract) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.commissionList.length === 0
        ? _c("empty-list")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteModalRef",
          attrs: {
            id: "delete-modal",
            size: "sm",
            title: "Aviso",
            centered: ""
          },
          on: { ok: _vm.handleDeleteCommission }
        },
        [
          _c("p", { staticClass: "my-4" }, [
            _vm._v("Deseja realmente excluir essa comissão?")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteModalInBatchRef",
          attrs: {
            id: "delete-modal-in-batch",
            size: "sm",
            title: "Aviso",
            centered: ""
          },
          on: { ok: _vm.handleDeleteCommissionItemInBatch }
        },
        [
          _c("p", { staticClass: "my-4" }, [
            _vm._v("Deseja realmente excluir todas essas comissões?")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }